import { AnimatedDeck, AnimatedSlidesState, Deck, SidebarState, ToolbarTabs } from '.';
import { DEFAULT_ANIMATED_SLIDES_STATE } from './getters';
import { User } from '../event/types';

import loggerService from '@/services/logger.service';
import { RootState } from '@/store';
import { deepClone } from '@/utils/objectUtil';

const mutations = {
  changePrimaryTab(state: SidebarState, tabName: SidebarState['selectedPrimaryTab'], rootState: RootState) {
    if (tabName) {
      state.selectedPrimaryTab = tabName;
    } else {
      state.selectedPrimaryTab = 'stage_chat';
    }
    if (state.selectedPrimaryTab !== 'messages_chat') {
      state.currentDirectChatId = null;
    }
  },
  closeP2PChat(state: SidebarState) {
    state.currentDirectChatId = null;
  },
  changeLiveSubTab(state: SidebarState, tabName: string) {
    if (tabName) {
      state.selectedLiveSubTab = tabName;
    }
  },
  changeQATab(state: SidebarState, tabName: string) {
    if (tabName) {
      state.selectedQnaTab = tabName;
    }
  },
  search(state: SidebarState, search: string) {
    state.messagesSearchFilter = search;
  },
  setmessagelistpage(state: SidebarState, page: number) {
    state.messageList.current = page;
  },
  setStageChatCurrentTabIndex(state: SidebarState, index: number) {
    state.stageChatSubTabIndex = index;
  },
  setCurrentDeck(state: SidebarState, deckId: string) {
    state.slideDecks.onsidebar = deckId;
  },
  setSlide(state: SidebarState, slide: Deck) {
    if (state.slideDecks.slides[slide.id]) {
      state.slideDecks.slides[slide.id] = slide;
    } else {
      Object.assign(state.slideDecks.slides, { [slide.id]: slide });
    }
  },
  addDeck(state: SidebarState, deck: Deck) {
    Object.assign(state.slideDecks.slides, { [deck.id]: Object.freeze(deck) });
  },
  resetSlideDecks(state: SidebarState) {
    state.slideDecks.slides = {};
  },
  removeSlideDeck(state: SidebarState, slideId: string) {
    delete state.slideDecks.slides[slideId];
  },
  setSpeakerProfile(state: SidebarState, speaker: User) {
    state.speakerProfile = speaker;
  },
  setCurrentToolbarTab(state: SidebarState, tab: ToolbarTabs) {
    state.selectedToolbarTab = tab;
  },

  setAnimatedSlidesState(state: SidebarState, payload: AnimatedSlidesState) {
    state.animatedSlides = {
      ...payload,
      maxStepCount: state.animatedSlides?.maxStepCount
    };
  },

  updateAnimatedSlidePosition(
    state: SidebarState,
    payload: { slideIndex: number; stepNumber: number; slide_state_version: number; action?: string }
  ) {
    if (state.animatedSlides) {
      state.animatedSlides.slideIndex = payload.slideIndex;
      state.animatedSlides.stepNumber = payload.stepNumber;
      state.animatedSlides.slide_state_version = payload.slide_state_version;
      state.animatedSlides.action = payload.action;
    }
  },

  updateMaxStepCount(state: SidebarState, count: number) {
    loggerService.log('[animated-slides] updateMaxStepCount: ', count);
    state.animatedSlides.maxStepCount = count;
  },

  updateSlideStepMap(state: SidebarState, map: Record<number, number>) {
    loggerService.log('[animated-slides] updateSlideStepMap: ', map);
    state.animatedSlides.slideStepMap = map;
  },

  clearAnimatedSlides(state: SidebarState) {
    state.animatedSlides = { ...DEFAULT_ANIMATED_SLIDES_STATE };
  },

  setCurrentAnimatedDeck(state: SidebarState, deckId: string) {
    state.animatedSlideDecks.onsidebar = deckId;
  },

  addAnimatedDeck(state: SidebarState, deck: AnimatedDeck) {
    Object.assign(state.animatedSlideDecks.decks, { [deck.id]: Object.freeze(deck) });
  },

  removeAnimatedDeck(state: SidebarState, deckId: string) {
    const newAnimatedSlideDecks = deepClone(state.animatedSlideDecks);
    delete newAnimatedSlideDecks.decks[deckId];
    state.animatedSlideDecks = newAnimatedSlideDecks;
  },

  resetAnimatedSlideDecks(state: SidebarState) {
    state.animatedSlideDecks.decks = {};
  }
};

export default mutations;
export type SidebarStateMutations = typeof mutations;
